<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：分组目录 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleCateTypeSelect('')"
              :class="{ 'selected': productCategoryManageInfo.conditions.cateType === '' }">
              全部
            </li>
            <li v-for="(item, index) in filteredCateTypes" :key="index"
              @click="handleCateTypeSelect(item.statusCd)"
              :class="{ 'selected': productCategoryManageInfo.conditions.cateType === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('productCategory.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="productCategoryManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="productCategoryManageInfo.conditions.categoryName"
                    :placeholder="$t('productCategory.inputName')" clearable />
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-select v-model="productCategoryManageInfo.conditions.isShow"
                    :placeholder="$t('productCategory.selectShowStatus')" style="width:100%" clearable>
                    <el-option v-for="(item, index) in productCategoryManageInfo.isShows" :key="index" :label="item.name"
                      :value="item.statusCd" />
                  </el-select>
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryProductCategoryMethod">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetProductCategoryMethod">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 商品分组表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('productCategory.productGroup') }}</div>
            <el-button type="primary" size="small" @click="_openAddProductCategoryModal">
              <i class="el-icon-plus"></i> {{ $t('common.add') }}
            </el-button>
          </div>
          <div class="">
            <el-table :data="productCategoryManageInfo.productCategorys" border style="width: 100%">
              <el-table-column prop="categoryId" :label="$t('productCategory.categoryId')" align="center" />
              <el-table-column prop="categoryName" :label="$t('productCategory.categoryName')" align="center" />
              <el-table-column prop="cateType" :label="$t('productCategory.groupType')" align="center">
                <template #default="scope">
                  {{ productCategoryManageInfo.cateTypeName[scope.row.cateType] }}
                </template>
              </el-table-column>
              <el-table-column prop="seq" :label="$t('productCategory.showOrder')" align="center" />
              <el-table-column prop="isShow" :label="$t('productCategory.isShow')" align="center">
                <template #default="scope">
                  {{ scope.row.isShow == 'Y' ? $t('common.yes') : $t('common.no') }}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('productCategory.createTime')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="200">
                <template #default="scope">
                  <el-button type="text" size="small" @click="_openEditProductCategoryModel(scope.row)">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button type="text" size="small" @click="_openDeleteProductCategoryModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="productCategoryManageInfo.conditions.page"
              :page-size="productCategoryManageInfo.conditions.row" layout="total, prev, pager, next"
              :total="productCategoryManageInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-product-category ref="addProductCategory" @refresh="_queryProductCategoryMethod" />
    <edit-product-category ref="editProductCategory" @refresh="_queryProductCategoryMethod" />
    <delete-product-category ref="deleteProductCategory" @refresh="_queryProductCategoryMethod" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryProductCategory } from '@/api/goods/productCategoryApi'
import AddProductCategory from '@/components/goods/addProductCategory/addProductCategory.vue'
import EditProductCategory from '@/components/goods/editProductCategory/editProductCategory.vue'
import DeleteProductCategory from '@/components/goods/deleteProductCategory/deleteProductCategory.vue'

export default {
  name: 'ProductCategoryManage',
  components: {
    AddProductCategory,
    EditProductCategory,
    DeleteProductCategory
  },
  data() {
    return {
      productCategoryManageInfo: {
        cateTypeName: ['', this.$t('productCategory.normalGoods'), this.$t('productCategory.specialGoods'), this.$t('productCategory.pointGoods')],
        productCategorys: [],
        total: 0,
        records: 1,
        moreCondition: false,
        categoryId: '',
        isShows: [],
        cateTypes: [],
        conditions: {
          categoryName: '',
          categoryLevel: '',
          cateType: '',
          isShow: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  computed: {
    // 过滤掉积分商品（cateType 为 '3'）
    filteredCateTypes() {
      return this.productCategoryManageInfo.cateTypes.filter(item => item.statusCd !== '3')
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      await this._listProductCategorys(1, 10)
      const { data: isShows } = await getDict('product_category', 'is_show')
      const { data: cateTypes } = await getDict('product_category', 'cate_type')
      this.productCategoryManageInfo.isShows = isShows
      this.productCategoryManageInfo.cateTypes = cateTypes
    },
    async _listProductCategorys(page, rows) {
      this.productCategoryManageInfo.conditions.page = page
      this.productCategoryManageInfo.conditions.row = rows
      let shopId = await getShopId();
      this.productCategoryManageInfo.conditions.shopId = shopId

      const params = {
        ...this.productCategoryManageInfo.conditions,
        categoryName: this.productCategoryManageInfo.conditions.categoryName.trim()
      }

      try {
        const res = await queryProductCategory(params)
        this.productCategoryManageInfo.total = res.total
        this.productCategoryManageInfo.records = res.records
        this.productCategoryManageInfo.productCategorys = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this._listProductCategorys(val, this.productCategoryManageInfo.conditions.row)
    },
    _openAddProductCategoryModal() {
      this.$refs.addProductCategory.open()
    },
    _openEditProductCategoryModel(row) {
      this.$refs.editProductCategory.open(row)
    },
    _openDeleteProductCategoryModel(row) {
      this.$refs.deleteProductCategory.open(row)
    },
    _queryProductCategoryMethod() {
      this._listProductCategorys(1, this.productCategoryManageInfo.conditions.row)
    },
    _resetProductCategoryMethod() {
      this.productCategoryManageInfo.conditions.categoryName = ''
      this.productCategoryManageInfo.conditions.cateType = ''
      this.productCategoryManageInfo.conditions.isShow = ''
      this._listProductCategorys(1, this.productCategoryManageInfo.conditions.row)
    },
    handleCateTypeSelect(cateType) {
      this.productCategoryManageInfo.conditions.cateType = cateType
      this.productCategoryManageInfo.conditions.page = 1
      this._listProductCategorys(1, this.productCategoryManageInfo.conditions.row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.ibox-title {
  padding: 15px 15px 7px;
  min-height: 48px;
  border-bottom: 1px solid #e7eaec;
}

.ibox-content {
  padding: 15px;
}

/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>